import React, { Component } from "react";

import { connect } from "react-redux";
import {
	Row,
	Col,
	Card,
	CardHeader,
	CardBody,
	Spinner,
	CardTitle,
	CardText,
} from "reactstrap";

//SimpleBar
import SimpleBar from "simplebar-react";
import "simplebar/src/simplebar.css";

import { Link } from "react-router-dom";
import TimeLineCard from "./timeLineCard";
import "./TimeLineLogRightbar.scss";
import {
	viewLogHideRightSidebarPurchase,
	getPurchaseOrderHistory,
	// GetItemTimeLine,
} from "../../store/SRPurchaseOrder/actions";
import moment from "moment";
class TimeLineLogRightbar extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.hideViewLogRightbar = this.hideViewLogRightbar.bind(this);
	}
	componentDidUpdate(prevProps) {
		const { PORowData, getPurchaseOrderHistory } = this.props;

		// Check if PORowData and required IDs exist and if they've changed
		if (
			PORowData &&
			PORowData.id &&
			PORowData.woitems &&
			PORowData.woitems.length > 0
		) {
			const poItemId = PORowData.woitems.find((e) => e.id)?.id;

			// Call API only if the ID exists and is different from the previous prop
			if (
				PORowData.id !== prevProps.PORowData?.id ||
				poItemId !== prevProps.PORowData?.woitems?.find((e) => e.id)?.id
			) {
				getPurchaseOrderHistory({
					poId: PORowData.id,
					poItemId: poItemId,
				});
			}
		}
	}

	/**
	 * Hides the right sidebar
	 */
	hideViewLogRightbar(e) {
		e.preventDefault();
		this.props.viewLogHideRightSidebarPurchase();
	}

	render() {
		return (
			<React.Fragment>
				<div className="timeLine-right-bar">
					<div className="rightbar-title px-3 py-4">
						<Link
							to="#"
							onClick={this.hideViewLogRightbar}
							className="right-bar-toggle float-right">
							<i className="mdi mdi-close noti-icon"></i>
						</Link>
						<h5 className="m-0">Time Line</h5>
					</div>
					<hr className="my-0" />

					<Row>
						{/* -------- Items List ----------  */}
						<Col md={3}>
							<div className="px-1 py-1">
								<SimpleBar style={{ height: " 90vh" }}>
									<Card body outline color="primary">
										<CardHeader className="bg-transparent border-bottom ml-0">
											<h5 className="mb-0 ">
												Work Order Items List (
												<span className="text-primary">
													{this.props.PORowData?.code}
												</span>
												)
											</h5>
										</CardHeader>
										<CardBody className="p-0">
											<div id="Items-menu">
												<ul
													className="metismenu list-unstyled"
													id="Items-menu">
													{this.props?.PORowData
														?.woitems?.length ===
													0 ? (
														<>
															{this.props
																.loading && (
																<div className="text-center">
																	<Spinner color="primary" />
																</div>
															)}
														</>
													) : (
														<>
															{this.props.PORowData?.woitems?.map(
																(item, i) => (
																	<li key={i}>
																		<Link
																			to="#"
																			onClick={() => {
																				this.props.getPurchaseOrderHistory(
																					{
																						poId: this
																							.props
																							.PORowData
																							?.id,
																						poItemId:
																							item?.id,
																					}
																				);
																			}}
																			className={
																				item.id ===
																				this
																					.props
																					.itemSelectedId
																					? "waves-effect Item-active"
																					: "waves-effect"
																			}
																			id={
																				item.code
																			}>
																			<span>
																				{
																					item
																						.product
																						.name
																				}
																			</span>
																		</Link>
																	</li>
																)
															)}
														</>
													)}
												</ul>
											</div>
										</CardBody>
									</Card>
								</SimpleBar>
							</div>
						</Col>
						{/* -------- Time line View ----------  */}
						<Col data-simplebar md={9}>
							<Card body outline color="primary">
								<CardHeader className="bg-transparent border-bottom">
									<h5 className="mb-0">PO Item Time Line</h5>
								</CardHeader>
								<CardBody className="p-0 mb-4">
									<SimpleBar style={{ height: " 90vh" }}>
										{this.props.loading && (
											<div className="text-center mt-2">
												<span className="text-primary">
													Loading...
												</span>
											</div>
										)}
										<div className="TimeLineBody mb-4">
											<div class="TimeLine-box mb-4">
												<ul>
													{this.props.POItemHistory
														?.length != 0 ? (
														this.props.POItemHistory?.map(
															(item, i) => (
																<li key={i}>
																	<span></span>
																	<Card
																		outline
																		// color={
																		// 	"primary"
																		// }
																		color={
																			item.change_type ===
																			1
																				? "success"
																				: item.change_type ===
																				  2
																				? "warning"
																				: item.change_type ===
																				  3
																				? "danger"
																				: "primary"
																		}
																		className="border">
																		<CardHeader
																			className={
																				item.change_type ===
																				1
																					? "bg-success"
																					: item.change_type ===
																					  2
																					? "bg-warning"
																					: item.change_type ===
																					  3
																					? "bg-danger"
																					: "bg-primary"
																			}>
																			<h5 className="my-0 text-white">
																				<i className="mdi mdi-bullseye-arrow mr-3"></i>
																				PO
																				Item{" "}
																				{item.change_type ===
																				1
																					? "Created"
																					: item.change_type ===
																					  2
																					? "Updated"
																					: item.change_type ===
																					  3
																					? "Deleted"
																					: "Initalized"}

																				(
																				{
																					item.purchaseorder
																				}

																				)
																				<span className="float-right">
																					{
																						item
																							.modified_by
																							.fullname
																					}

																					(
																					{
																						item
																							.modified_by
																							.username
																					}

																					)
																				</span>
																			</h5>
																		</CardHeader>
																		<CardBody>
																			<CardTitle className="mb-0 pb-0 font-size-16 text-dark">
																				{
																					item
																						.product
																						.name
																				}
																			</CardTitle>

																			<CardText className="info w-100 d-flex justify-content-between">
																				<div>
																					<p className="mb-0">
																						<b className="text-dark">
																							Item
																							Base
																							Price:
																						</b>{" "}
																						<span className="font-weight-medium">
																							{
																								item.baseprice
																							}
																							{/* {item.unit.name} */}
																						</span>
																					</p>
																					<p className="mb-0">
																						<b className="text-dark">
																							Item
																							Discount(%):
																						</b>{" "}
																						<span className="font-weight-medium">
																							{
																								item.discountpercent
																							}
																							{/* {item.unit.name} */}
																						</span>
																					</p>
																					<p className="mb-0">
																						<b className="text-dark">
																							Item
																							Price:
																						</b>{" "}
																						<span className="font-weight-medium">
																							{
																								item.price
																							}
																						</span>
																					</p>
																				</div>

																				<div>
																					<p className="mb-0">
																						<b className="text-dark">
																							Tax
																							Type(%):
																						</b>{" "}
																						<span className="font-weight-medium">
																							{
																								item.taxtype_name
																							}{" "}
																							{
																								item
																									.tax
																									.name
																							}
																						</span>
																					</p>
																					<p className="mb-0">
																						<b className="text-dark">
																							Tax
																							Type(%):
																						</b>{" "}
																						<span className="font-weight-medium">
																							{
																								item.taxtype_name
																							}{" "}
																							{
																								item
																									.tax
																									.name
																							}
																						</span>
																					</p>

																					<p className="mb-0">
																						<b className="text-dark">
																							Gross
																							value:
																						</b>{" "}
																						<span className="font-weight-medium">
																							{
																								item.gross
																							}
																						</span>
																					</p>
																				</div>
																				{/* <p className="mb-0">
																					<b className="text-dark">
																						Quantity:
																					</b>{" "}
																					<span className="font-weight-medium">
																						{
																							item.qty
																						}
																					</span>
																				</p> */}
																			</CardText>
																		</CardBody>
																	</Card>

																	<div class="time text-primary">
																		<span>
																			{moment(
																				item.modifiedon
																			).format(
																				"DD-MM-YYYY"
																			)}
																			<br />
																			{moment(
																				item.modifiedon
																			).format(
																				"LTS"
																			)}
																		</span>
																	</div>
																</li>
															)
														)
													) : (
														<li>No Data</li>
													)}
												</ul>
											</div>
										</div>
									</SimpleBar>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
				<div
					className="timeLine-right-bar-overlay"
					onClick={this.hideViewLogRightbar}>
					{" "}
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const {
		// Material_id,
		// mrItemsList,
		// mrIssueItem,
		// itemTimeLine,
		// itemSelectedId,
		// PIitemTimeLine,
		// RFQItemsTimeLine,
		// wOItemsTimeLine,
		// IGPItemsTimeLine,

		loading,
		PORowData,
		POItemHistory,
	} = state.SRPurchaseOrder;

	return {
		// Material_id,
		// mrItemsList,
		// mrIssueItem,
		// itemTimeLine,
		// itemSelectedId,
		// PIitemTimeLine,
		// RFQItemsTimeLine,
		// wOItemsTimeLine,
		// IGPItemsTimeLine,

		loading,
		PORowData,
		POItemHistory,
	};
};

export default connect(mapStatetoProps, {
	viewLogHideRightSidebarPurchase,
	getPurchaseOrderHistory,
	// GetItemTimeLine,
})(TimeLineLogRightbar);
